export default __webpack_public_path__ + "static/media/animatedBackground-reverted.b25b3dd4.svg";